import type { FeedbackOption } from './types';

export const FEEDBACK_QUESTION =
  'Quanto sono chiare le informazioni su questa pagina?';

export const FEEDBACK_POSITIVE_QUESTION =
  'Quali sono stati gli aspetti che hai preferito?';

export const FEEDBACK_NEGATIVE_QUESTION =
  'Dove hai incontrato le maggiori difficoltà?';

export const FEEDBACK_DETAILS_QUESTION = 'Vuoi aggiungere altri dettagli?';

export const FEEDBACK_DETAILS_PLACEHOLDER = 'Dettaglio';

export const FEEDBACK_DETAILS_MAX_CHARS = 200;

export const FEEDBACK_DETAILS_HELP_TEXT =
  '*Inserire massimo 200 caratteri';

export const FEEDBACK_THANK_YOU_MESSAGE =
  'Grazie, il tuo parere ci aiuterà a migliorare il sito!';

export const FEEDBACK_POSITIVE_THRESHOLD = 3;

export const FEEDBACK_FORM_SLUG = 'feedback-1789648785414';

export const FEEDBACK_POSITIVE_OPTIONS: FeedbackOption[] = [
  {
    value: 'Le indicazioni erano chiare',
    label: 'Le indicazioni erano chiare',
  },
  {
    value: 'Le indicazioni erano complete',
    label: 'Le indicazioni erano complete',
  },
  {
    value: 'Non ho avuto dubbi su quello che stavo facendo',
    label: 'Non ho avuto dubbi su quello che stavo facendo',
  },
  {
    value: 'Non ho avuto problemi tecnici',
    label: 'Non ho avuto problemi tecnici',
  },
  { value: 'Altro', label: 'Altro' },
];

export const FEEDBACK_NEGATIVE_OPTIONS: FeedbackOption[] = [
  {
    value: 'A volte le indicazioni non erano chiare',
    label: 'A volte le indicazioni non erano chiare',
  },
  {
    value: 'A volte le indicazioni non erano complete',
    label: 'A volte le indicazioni non erano complete',
  },
  {
    value: 'A volte non capivo se stavo procedendo correttamente',
    label: 'A volte non capivo se stavo procedendo correttamente',
  },
  {
    value: 'Ho avuto problemi tecnici',
    label: 'Ho avuto problemi tecnici',
  },
  { value: 'Altro', label: 'Altro' },
];
